import {
  Card,
  CardContent,
  Typography
} from '@mui/material';
import { isSessionEnded } from '../isInSession';
import { useGetSessionQuery, useGetUserInfoQuery } from '../services/api';
import { MemberActions } from './MemberActions';
import { PractitionerActions } from './PractitionerActions';

export function SessionActionsCard({
  guid,
  inSession,
}: {
  guid?: string;
  inSession: boolean
}) {
  const { data: session } = useGetSessionQuery(guid);
  const { data: user } = useGetUserInfoQuery();

  return (
    <Card
      style={{
        marginTop: 10,
      }}
    >
      <CardContent>
        {user?.role === 'practitioner' || inSession || isSessionEnded(session)
          ? null
          : <>
            <Typography
              gutterBottom
              textAlign='center'
            ><span
              style={{
                fontWeight: 500
              }}
            >{session?.seats}</span> Seats Available</Typography>
          </>
        }
        <MemberActions
          guid={guid}
          inSession={inSession}
        />
        <PractitionerActions
          guid={guid}
          inSession={inSession}
        />
      </CardContent>
    </Card>
  );
}
